<template>
  <a-layout>
    <a-layout>
      <a-layout-header>
        <PageHeader/>
      </a-layout-header>
      <a-layout>
        <a-layout-sider width="200" style="background: #fff" v-if="!hideSider">
          <PageSider/>
        </a-layout-sider>
        <a-layout style="padding: 5px 12px 12px">
          <a-breadcrumb style="margin: 16px 0; text-align: left; display: none;">
            <a-breadcrumb-item>Home</a-breadcrumb-item>
            <a-breadcrumb-item>List</a-breadcrumb-item>
            <a-breadcrumb-item>App</a-breadcrumb-item>
          </a-breadcrumb>
          <a-layout-content :style="{  padding: '6px 0px', margin: 0, minHeight: '280px' }">
            <keep-alive :include="['orderList']">
              <router-view class="content-view"></router-view>
            </keep-alive>
          </a-layout-content>
        </a-layout>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import PageHeader from './page-header'
import PageSider from './page-sider'
export default {
  name: 'PageLayout',
  components: {
    PageHeader: PageHeader,
    PageSider: PageSider
  },
  data() {
    return {
    }
  },
  computed: {
    hideSider() {
      const route = this.$route
      const { hideSider } = route.meta
      return hideSider
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-layout-header {
  height: 60px !important;
  line-height: 60px !important;
  padding: 0!important;
  margin-bottom: 3px;
}
</style>